import ComcastImages from "./comcast-image-library.json";

const getCustomImageLibrary = (organizationName?: string) => {
  switch (organizationName?.toLowerCase()) {
    case "comcast":
      return ComcastImages;
    default:
      return [];
  }
};

export default getCustomImageLibrary;
